import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatMoney } from '../../Shared/Formatters';

/**
 * Horizontal bar chart widget — Top N Performers, Category Distribution (bar variant).
 * Self-rendered without ApexCharts for speed; each bar is a <div>.
 */
export default function BarChartWidget({ data }) {
    const { t } = useTranslation();
    if (!data?.data) return null;
    const rows = Array.isArray(data.data) ? data.data : [];
    if (!rows.length) return <div style={{ padding: 20 }} className="v3-body">{t('No data')}</div>;

    const max = Math.max(...rows.map(r => r.sales ?? r.totalSales ?? r.value ?? 0));

    return (
        <div style={{ padding: '6px 18px 14px' }}>
            {rows.slice(0, 5).map((row, i) => {
                const label = row.tenantName || row.category || row.tenant_name || row.name || '—';
                const value = row.sales ?? row.totalSales ?? row.value ?? 0;
                const pct = max > 0 ? (value / max) * 100 : 0;
                return (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '5px 0' }}>
                        <span className="v3-body" style={{ width: 80, textAlign: 'right', fontSize: 12 }}>{label}</span>
                        <div style={{ flex: 1, height: 24, background: 'var(--v3-bg-surface)', borderRadius: 8, overflow: 'hidden' }}>
                            <div style={{
                                width: `${pct}%`,
                                height: '100%',
                                background: 'linear-gradient(90deg, var(--v3-accent), var(--v3-teal))',
                                opacity: 1 - (i * 0.12),
                                borderRadius: 8,
                                transition: 'width 0.5s ease',
                            }} />
                        </div>
                        <span style={{
                            width: 85, fontFamily: 'JetBrains Mono, monospace', fontSize: 11,
                            color: 'var(--v3-text-muted)'
                        }}>{formatMoney(value)}</span>
                    </div>
                );
            })}
        </div>
    );
}
